export default __webpack_public_path__ + "static/INSTAR_Cloud_Alexa_Skill_16-EN-01ee90c8f832665679463d0b40f13fe8.webp";